module.exports = __webpack_public_path__ + "static/media/Roboto-Thin.89e2666c.ttf";